var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({content: _vm.$props.content, trigger: 'click hover'}),expression:"{content: $props.content, trigger: 'click hover'}"}],staticClass:"hover-tooltip",attrs:{"src":"/assets/images/tooltip.svg","alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }